var React = require('react');

function IcPlayArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ic_play_arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"AV","transform":"translate(-56.000000, -245.000000)"},React.createElement("g",{"id":"ic_play_arrow","transform":"translate(48.000000, 240.000000)"},React.createElement("g",{"id":"Icon-24px"},[React.createElement("polygon",{"fill":"#000000","points":"8 5 8 19 19 12","key":0}),React.createElement("polygon",{"points":"0 0 24 0 24 24 0 24","key":1})]))))]);
}

IcPlayArrow.defaultProps = {"width":"11px","height":"14px","viewBox":"0 0 11 14","version":"1.1"};

module.exports = IcPlayArrow;

IcPlayArrow.default = IcPlayArrow;
